import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import toast from "react-hot-toast";
import { BASE_IMAGES_URL, APP_API_KEY } from "@constant";
import { resetPassword } from "@mainaction";
import {
  renderFieldText,
  renderFieldCheckbox,
  validateEmail,
  classNames,
  startsWithKY,
} from "@basecomponent";
import LocaleStrings from "@language";

function ResetPassword(props) {
  const navigate = useNavigate();
  const location = useLocation();
  var {
    handleSubmit,
    pristine,
    invalid,
    submitting,
    reset,
    session,
    eventData,
  } = props;
  var [loading, setLoading] = useState(false);
  var [resetAction, setResetAction] = useState(false);

  const email = new URLSearchParams(useLocation().search).get("email");
  const code = new URLSearchParams(useLocation().search).get("code");

  useEffect(() => {
    if (email) {
      props.autofill("email", email);
    }
  }, [email, code]);

  const onSubmitForm = (values) => {
    setLoading(true);
    props.resetPassword(values, (res) => {
      setLoading(false);
      reset();
      if (res.success) {
        toast.success(LocaleStrings.reset_password_update_success);
        navigate("/login");
      } else {
        toast.error(res.message);
      }
    });
  };

  return (
    <>
      <div className="min-h-full">
        <div className="flex items-center justify-center mt-6 text-2xl text-primary">
          <h2 className="mt-6 text-3xl font-extrabold text-primary">
            {LocaleStrings.reset_password}
          </h2>
        </div>
        <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div className="mt-8 border rounded-md p-7 shadow-md">
              <form onSubmit={handleSubmit(onSubmitForm)} className="space-y-6">
                <Field
                  name="email"
                  label={LocaleStrings.login_form_label_email}
                  placeholder={LocaleStrings.login_form_ph_email}
                  type="text"
                  component={renderFieldText}
                  mandatory="true"
                  maxlength={100}
                  readOnly={true}
                />
                <Field
                  name="resetcode"
                  label={LocaleStrings.reset_password_form_label_code}
                  placeholder={LocaleStrings.reset_password_ph_label_code}
                  type="text"
                  component={renderFieldText}
                  mandatory="true"
                  maxlength={100}
                />

                <Field
                  name="password"
                  label={LocaleStrings.login_form_label_password}
                  placeholder={LocaleStrings.login_form_ph_password}
                  type="password"
                  component={renderFieldText}
                  mandatory="true"
                  maxlength={100}
                />
                <Field
                  name="conf_password"
                  label={LocaleStrings.reset_password_form_label_conf_password}
                  placeholder={
                    LocaleStrings.reset_password_ph_label_conf_password
                  }
                  type="password"
                  component={renderFieldText}
                  mandatory="true"
                  maxlength={100}
                />

                <div>
                  <button
                    className="w-full theme-button-md"
                    disabled={pristine || invalid || submitting || loading}
                  >
                    <svg
                      className={classNames(
                        loading ? "" : "hidden",
                        "cust-btn-spinner"
                      )}
                      viewBox="0 0 1024 1024"
                      focusable="false"
                      data-icon="btnloading"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                    </svg>
                    {LocaleStrings.button_save}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const validate = (values) => {
  var errors = {};
  var email = values["email"];
  var password = values["password"];
  var conf_password = values["conf_password"];
  var resetcode = values["resetcode"];

  if (!email || email.trim() === "") {
    errors["email"] = LocaleStrings.required;
  } else if (!validateEmail(email)) {
    errors["email"] = LocaleStrings.invalid_email;
  }
  if (!resetcode || resetcode === "") {
    errors["resetcode"] = LocaleStrings.required;
  }
  if (!password || password === "") {
    errors["password"] = LocaleStrings.required;
  }
  if (!conf_password || conf_password === "") {
    errors["conf_password"] = LocaleStrings.required;
  } else if (password != conf_password) {
    errors["conf_password"] = LocaleStrings.conf_password_not_match;
  }

  return errors;
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    eventData: state.eventData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ resetPassword }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "ResetpwdForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ResetPassword)
);
